import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const VipDetailsStyle = {
  banner: css`
    margin-bottom: 10px;
    img {
      width: 100%;
      height: 100%;
      border-bottom: solid 20px ${theme.colors.orange[200]};
    }
  `,

  wrapper: css`
    position: relative;
  `,

  swiper: css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,

  groupBenefit: css`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    gap: 20px;

    position: absolute;

    left: 50%;
    top: 260px;
    width: 450px;

    transform: translateX(-50%);
  `,

  textBox: css`
    position: absolute;
    top: 85px;
    text-align: center;
    width: 100%;
    padding: 0 10px;

    span {
      color: #000;
      font-family: "Roboto";
      font-style: normal;
      font-size: 16px;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      line-height: 1.42857143;
    }
  `,

  itemBenefit: css`
    width: 120px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `,

  mainContent: css`
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `,
};
